// extracted by mini-css-extract-plugin
export var authorDetails = "blogAuthorThumbnail-module--authorDetails--4985a";
export var authorImage = "blogAuthorThumbnail-module--authorImage--ebbf9";
export var authorImageFrame = "blogAuthorThumbnail-module--authorImageFrame--e9e71";
export var authorName = "blogAuthorThumbnail-module--authorName--c0e74";
export var dark = "blogAuthorThumbnail-module--dark--4fddd";
export var klaviyoLogo = "blogAuthorThumbnail-module--klaviyoLogo--a5e21";
export var light = "blogAuthorThumbnail-module--light--22b92";
export var readTime = "blogAuthorThumbnail-module--readTime--8abc2";
export var row = "blogAuthorThumbnail-module--row--d5017";